import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";


export const fetchPendingPayouts = async ({ user, page, limit }) => {

    try {
      const params = `?page=${page}&limit=${limit}&compact=0`
      const { data } = await axios.get(`${API_BASE_URL}/agbk/payouts/pending/list${params}`,
        buildHeaders(user))
      return data?.data
    } catch (err) {
      console.log(err)
      throw err
    }
  }
  
  export const approvePayout = async ({ user, uuid, iban, bank_name, amount, ago_withdraw_id }) => {
  
    try {
      const { data } = await axios.post(`${API_BASE_URL}/agbk/payouts/approve`,
        { uuid, iban, bank_name, amount, ago_withdraw_id },
        buildHeaders(user))
      return data?.data
    } catch (err) {
      console.log(err)
      throw err
    }
  }